export enum AppRouter {
  DisplayNoneRoute,
  FloatingActionButtonRoute,
  SatisfactionRatingRoute,
  FeedbackSectionRoute,
  QuestionSectionRoute,
  ThankYouSectionRoute,
  TabbedWidgetRoute,
  ConnectionErrorRoute,
  SurveyRoute,
}
